// Depends
import { subGroup, route, professionalMeta } from '@/helpers/routes'
import Index from './index/index'
import Form from './form/form'

const routes = [
  route('index', '/index', Index, professionalMeta('Lista de Funcionários')),
  route('create', '/create', Form, professionalMeta('Adicionar Funcionário'))
]

export default subGroup('/employees', routes)



// WEBPACK FOOTER //
// ./src/app/professional/company/employees/routes.js